import { lazy } from 'react';

export const OnlineArchivePage = lazy(() => import('./OnlineArchivePage'));
export const OnlineArchiveSettingsPage = lazy(() => import('./OnlineArchiveSettingsPage'));
